import IframeResizer from 'iframe-resizer-react';
import React from 'react';

export const RioAppNavigatorDropdown: React.FC = () => {
  return <IframeResizer src={'https://menu.rio.cloud'} />;
};
